import { MessagingSettings } from '@weave/schema-gen-ts/dist/schemas/messaging/settings/v1/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaMessagingSettingsV1Service = bindHTTP(MessagingSettings);
